var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8333 8.66683C9.6367 8.66683 8.66665 9.63688 8.66665 10.8335V41.1668C8.66665 42.3634 9.6367 43.3335 10.8333 43.3335H41.1666C42.3633 43.3335 43.3333 42.3634 43.3333 41.1668V10.8335C43.3333 9.63688 42.3633 8.66683 41.1666 8.66683H10.8333ZM4.33331 10.8335C4.33331 7.24365 7.24346 4.3335 10.8333 4.3335H41.1666C44.7565 4.3335 47.6666 7.24365 47.6666 10.8335V41.1668C47.6666 44.7567 44.7565 47.6668 41.1666 47.6668H10.8333C7.24346 47.6668 4.33331 44.7567 4.33331 41.1668V10.8335Z",
    fill: "#C2CFE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4166 17.3335C17.8183 17.3335 17.3333 17.8185 17.3333 18.4168C17.3333 19.0151 17.8183 19.5002 18.4166 19.5002C19.015 19.5002 19.5 19.0151 19.5 18.4168C19.5 17.8185 19.015 17.3335 18.4166 17.3335ZM13 18.4168C13 15.4253 15.4251 13.0002 18.4166 13.0002C21.4082 13.0002 23.8333 15.4253 23.8333 18.4168C23.8333 21.4084 21.4082 23.8335 18.4166 23.8335C15.4251 23.8335 13 21.4084 13 18.4168Z",
    fill: "#C2CFE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1346 20.1348C33.9807 19.2886 35.3526 19.2886 36.1987 20.1348L47.032 30.9681C47.8782 31.8142 47.8782 33.1861 47.032 34.0322C46.1859 34.8784 44.8141 34.8784 43.9679 34.0322L34.6666 24.731L12.3654 47.0322C11.5192 47.8784 10.1474 47.8784 9.30125 47.0322C8.45511 46.1861 8.45511 44.8142 9.30125 43.9681L33.1346 20.1348Z",
    fill: "#C2CFE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgUploadIcon);
export default __webpack_public_path__ + "static/media/svg-upload-icon.a72bf14faf09c81175022f4d0a3c1587.svg";
export { ForwardRef as ReactComponent };